const DigitalClock = ({ timeElems }: { timeElems: number[] }) => {
  const twClasses = `font-mono text-xl text-stone-500 py-2 px-4 bg-neutral-100 border border-slate-400 rounded-md shadow-md`;
  return (
    <div className="flex justify-center p-5 mt-2">
      <div className={twClasses}>{`${timePad(timeElems[0])}:${timePad(
        timeElems[1]
      )}:${timePad(timeElems[2])}`}</div>
    </div>
  );
};

function timePad(el: number) {
  let elem = String(el);
  if (elem.length === 2) {
    return elem;
  }
  return `0${elem}`;
}

export { DigitalClock };
